//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import LoaderTasksTable from "src/components/loader/table/LoaderTasksTable";

const LoaderTasksPage = ({enabledFeatures}) => {
  return (
    <React.Fragment>
      <Typography variant="body2" color="textSecondary">
        <h5>Results</h5>
        <hr/>
      </Typography>
      <div>
        <div style={{marginTop: 20}}>
          <LoaderTasksTable enabledFeatures={enabledFeatures}/>
        </div>
      </div>
    </React.Fragment>
  );
};
export default LoaderTasksPage;
